import React, { useState, useEffect, useContext } from "react";
import HeartToSoulImage from "../../../../Assets/Images/HeartToSoulImageOne.png";
import HeartIcon from "../../../../Assets/Images/Heart-Icon.png";
import SoulIcon from "../../../../Assets/Images/SOUL.png";
import MindIcon from "../../../../Assets/Images/MIND.png";
import StrengthIcon from "../../../../Assets/Images/STRENGTH.png";
import flow_HM from '../../../../Assets/Images/flowScoreIcons/H-M.png'
import flow_HS from '../../../../Assets/Images/flowScoreIcons/H-S.png'
import flow_HST from '../../../../Assets/Images/flowScoreIcons/H-ST.png'
import flow_MH from '../../../../Assets/Images/flowScoreIcons/M-H.png'
import flow_MS from '../../../../Assets/Images/flowScoreIcons/M-S.png'
import flow_MST from '../../../../Assets/Images/flowScoreIcons/M-ST.png'
import flow_SH from '../../../../Assets/Images/flowScoreIcons/S-H.png'
import flow_SM from '../../../../Assets/Images/flowScoreIcons/S-M.png'
import flow_SST from '../../../../Assets/Images/flowScoreIcons/S-ST.png'
import flow_STH from '../../../../Assets/Images/flowScoreIcons/ST-H.png'
import flow_STM from '../../../../Assets/Images/flowScoreIcons/ST-M.png'
import flow_STS from '../../../../Assets/Images/flowScoreIcons/ST-S.png'
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import ArrowRight from '../../../../Assets/Images/arrow-right.png';
import GroupReportContext from "../../../../Context/GroupReportContext";
import { applyFullTieOrder } from "../../../../utils/quadrantTieOrder";

function HeartToSoulPreview360({ apiData, reportType, pageNumber }) {

  const [highestStarter, setHighestStarter] = useState('')
  const [mostSelecTedStarter, setMostSelecTedStarter] = useState('')
  const [secondMostSelecTedStarter, setSecondMostSelecTedStarter] = useState('')
  const [snapshotResult, setSnapshotResults] = useState([])
  const [starterLabel, setStarterLabel] = useState([])

  const [variablsMapArray, setVariableMapArray] = useState()
  const [scoreRanking, setScoreRanking] = useState([])
  const [aggregated360Results, setAggregated360Results] = useState([]);
  const [aggregated360Label, setAggregated360Label] = useState([]);
  const [aggregated360Highest, setAggregated360Highest] = useState("");

  const { starterFlow, averagePercentagesSelf, averagePercentages } = useContext(GroupReportContext);
  const sorted360AvgPercentage = applyFullTieOrder(averagePercentages?.slice().sort((a, b) => b.avg - a.avg), (el) => el.name, (el) => el.avg)?.map((el) => { return { name: el.name?.toLowerCase(), value: el.avg } })
  const sorted360AvgPercentageSelf = applyFullTieOrder(averagePercentagesSelf?.slice().sort((a, b) => b.avg - a.avg), (el) => el.name, (el) => el.avg)?.map((el) => { return { name: el.name?.toLowerCase(), value: el.avg } })

  // helper: show two decimals without rounding (truncate)
  const fmt2 = (n) => (Math.floor((Number(n) || 0) * 100) / 100).toFixed(2);

  const variablesKey = JSON.stringify(apiData?.variables ?? []);
  const membersKey = JSON.stringify(apiData?.memberResults?.allMembersData ?? null);

  useEffect(() => {
    if (!apiData?.variables) return;
    const nextMap = apiData.variables.reduce((acc, el) => {
      acc[el.variable] = el.score;
      return acc;
    }, {});
    setVariableMapArray((prev) => {
      const prevStr = prev ? JSON.stringify(prev) : null;
      const nextStr = JSON.stringify(nextMap);
      if (prevStr === nextStr) return prev;
      return nextMap;
    });
  }, [variablesKey]);

  useEffect(() => {
    getMostSecondMostStarter()
  }, [averagePercentages, averagePercentagesSelf]);

  const getMostSecondMostStarter = () => {
    if (sorted360AvgPercentage) {
      setMostSelecTedStarter(sorted360AvgPercentage[0]?.name);
      setSecondMostSelecTedStarter(sorted360AvgPercentage[1]?.name);
    }
  }

  const getFlowImage = () => {
    const images = {
      HS: flow_HS,
      HM: flow_HM,
      HST: flow_HST,
      MH: flow_MH,
      MS: flow_MS,
      MST: flow_MST,
      SH: flow_SH,
      SM: flow_SM,
      SST: flow_SST,
      STH: flow_STH,
      STM: flow_STM,
      STS: flow_STS,
    };
    const mapStarter = (starter) => {
      if (starter?.includes("str")) return "ST";
      return starter?.split("_")[0][0]?.toUpperCase();
    };

    const key = `${mapStarter(mostSelecTedStarter)}${mapStarter(secondMostSelecTedStarter)}`;
    return images[key?.toUpperCase()] || HeartToSoulImage;
  };

  const getFlowHead = () => {
    const flowMapping = {
      HS: "HEART TO SOUL",
      HM: "HEART TO MIND",
      HST: "HEART TO STRENGTH",
      MH: "MIND TO HEART",
      MS: "MIND TO SOUL",
      MST: "MIND TO STRENGTH",
      SH: "SOUL TO HEART",
      SM: "SOUL TO MIND",
      SST: "SOUL TO STRENGTH",
      STH: "STRENGTH TO HEART",
      STM: "STRENGTH TO MIND",
      STS: "STRENGTH TO SOUL",
    };

    const mapStarter = (starter) => {
      if (starter?.includes("str")) return "ST";
      return starter?.split("_")[0][0]?.toUpperCase();
    };

    const key = `${mapStarter(mostSelecTedStarter)}${mapStarter(secondMostSelecTedStarter)}`;
    const flowText = flowMapping[key] || "";
    return flowText;
  };


  const sectionFlowContent = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": `This type of person is grounded in feelings and meaning, valuing inner experiences and simply "being" over outward actions and achievements.`,
      "HEART TO MIND": "The Heart-to-Mind person feels first and thinks second. They start by caring, then add understanding to what's already unfolding. Once they feel grounded, they begin to strategize. Though much of this process happens within, they always bring it back to relationships, where they can openly explore and refine their ideas.",
      "HEART TO STRENGTH": "The Heart-to-Strength person is fueled by emotional energy and a focus on action. They're naturally driven by their feelings, wants, and needs, which motivate them to get things done.",
      "MIND TO HEART": "The Mind-to-Heart shift moves from logic to emotional connection, from head to heart.",
      "MIND TO SOUL": "People on the Mind-to-Soul path start with a clear plan and gradually seek deeper meaning, aiming to fit their ideas into a bigger, more meaningful picture.",
      "MIND TO STRENGTH": "People moving from Mind to Strength blend clear thinking with action. They're the \"think smarter, work harder\" type, constantly tweaking their strategies to get better results.",
      "SOUL TO HEART": "Soul-to-Heart individuals prioritize presence, relational depth, and meaningful connections. With an innate ability to connect emotionally, they inspire trust and loyalty through their genuine, authentic nature. They navigate life thoughtfully, seeing beyond the surface.",
      "SOUL TO MIND": "These people begin with depth, meaning, and vision, creating ideas to bring their insights to life. They organize and structure their inner world, and if they need a new structure, they'll invent it.",
      "SOUL TO STRENGTH": "Soul-to-Strength individuals quickly turn deep insights into action. They skip long planning phases, bringing the soul's depth straight into real-world impact.",
      "STRENGTH TO HEART": "Strength-to-Heart individuals dive into their missions with enthusiasm and passion, often bringing a welcoming attitude that quickly draws others in.",
      "STRENGTH TO MIND": "Strength-to-Mind individuals are fueled by action and a constant urge to make things better, always asking, \"How can this improve?\" This relentless drive for progress helps them advance quickly and find success.",
      "STRENGTH TO SOUL": "Strength-to-Soul individuals are dynamic visionaries who seek deeper meaning in their work, beyond just hitting goals.",
    };

    return contentMap[flowText] || "";
  };

  const flowTagline = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Feels good. But why?",
      "HEART TO MIND": "Feels good; I need to understand.",
      "HEART TO STRENGTH": "Feels good. Let's go!",
      "MIND TO HEART": "Makes sense, who do I need? ",
      "MIND TO SOUL": "Makes sense, but why?",
      "MIND TO STRENGTH": "Makes sense; let's go!",
      "SOUL TO HEART": "This is meaningful; let's feel it.",
      "SOUL TO MIND": "This is meaningful; let's design it.",
      "SOUL TO STRENGTH": "This is meaningful; let's do something.",
      "STRENGTH TO HEART": "I'm doing this. Who's in?",
      "STRENGTH TO MIND": "I'm doing this. How can it be better?",
      "STRENGTH TO SOUL": "I'm doing this, but why?",
    };

    return contentMap[flowText] || "";
  }

  const paraOne = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Heart-to-Soul individuals are guided by identity, values, and purpose. Rather than leading from the front, they create environments where life, love, and leadership can flourish naturally.",
      "HEART TO MIND": "This personality combines emotional connection with intellectual insight, creating a style that's both compassionate and strategically strong.",
      "HEART TO STRENGTH": "For them, shifting from heart to strength means moving from simply \"being\" to actively \"doing\"—from experiencing and connecting to making things happen in a tangible, practical way.",
      "SOUL TO MIND": "However, their carefully crafted plans can sometimes be hard to put into practice because they're based on big ideas and philosophy.",
      "MIND TO HEART": "These individuals, especially if relationally focused, prefer thoughtful and inclusive approaches over taking control. They need a deep understanding before they can fully invest or invite others in.",
      "MIND TO SOUL": "They commit to projects that match both their logical thinking and personal values, making their work both effective and fulfilling.",
      "MIND TO STRENGTH": "Focused on practical information and efficiency, they may sometimes overlook creativity, curiosity, or others' needs.",
      "SOUL TO HEART": "However, they may struggle in environments that value speed, competition, and strategy over depth and authenticity.",
      "SOUL TO STRENGTH": "Even without strong strategic or relational backing, their drive and commitment often lead to impressive, unexpected results.",
      "STRENGTH TO HEART": "They're natural motivators, using confidence, directness, and genuine empathy to kick-start projects and keep them going through emotional connection.",
      "STRENGTH TO MIND": "With a sharp focus on strategy and results, they sometimes overlook the emotional or cultural side of things, leaning toward efficiency over deeper relationships or cultural awareness. While they excel at getting things done, they may miss the nuances that create a more connected, balanced environment.",
      "STRENGTH TO SOUL": "They aim for their efforts to carry real significance, aligning personal values with professional goals. This means balancing practical actions with bigger visions to make their ideas a reality.",
    };

    return contentMap[flowText] || "";
  }

  const paraTwo = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Often seen as poets or creatives, they focus on soulful, intangible influence rather than conventional, straightforward strategies.",
      "HEART TO MIND": "",
      "HEART TO STRENGTH": "",
      "SOUL TO MIND": "",
      "MIND TO HEART": "Their clear thinking often brings calm to those seeking direction. Once they have a solid plan, they're ready to welcome others on board.",
      "MIND TO SOUL": "However, they may have many ideas and insights without taking much action, which can make them appear insightful but hard to pin down.",
      "MIND TO STRENGTH": "Mind-to-Strength individuals are direct, preferring to explain or show their ideas clearly, making them easy to understand.",
      "SOUL TO HEART": "",
      "SOUL TO STRENGTH": "",
      "STRENGTH TO HEART": "Their strong drive builds initial connections, but these relationships can be tested if goals or plans change. If others aren't aligned with their direction, they may be left behind.",
      "STRENGTH TO MIND": "",
      "STRENGTH TO SOUL": "Their high standards and shift toward purpose-driven goals can sometimes confuse or distance teammates used to simpler, more direct tasks. But despite these challenges, Strength-to-Soul people inspire others by showing how work can be both successful and deeply meaningful.",
    };

    return contentMap[flowText] || "";
  }

  const ArchtypeOne = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Deep Connector",
      "HEART TO MIND": "Collaborative Planner",
      "HEART TO STRENGTH": "Motivational Trailblazer",
      "SOUL TO MIND": "Purpose-Driven Innovator",
      "MIND TO HEART": "Strategic Connector",
      "MIND TO SOUL": "Philosophical Thinker",
      "MIND TO STRENGTH": "Continuous Improver",
      "SOUL TO HEART": "Authentic Guide",
      "SOUL TO STRENGTH": "Impactful Creator",
      "STRENGTH TO HEART": "Trusted Champion",
      "STRENGTH TO MIND": "Proactive Planner",
      "STRENGTH TO SOUL": "Genuine Influencer",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeTwo = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Grounded Guide",
      "HEART TO MIND": "Empathetic Guide",
      "HEART TO STRENGTH": "Passionate Doer",
      "SOUL TO MIND": "Visionary Architect",
      "MIND TO HEART": "Supportive Advisor",
      "MIND TO SOUL": "Insightful Innovator",
      "MIND TO STRENGTH": "Quick Problem-Solver",
      "SOUL TO HEART": "Compassionate Mentor",
      "SOUL TO STRENGTH": "Change Catalyst",
      "STRENGTH TO HEART": "Passionate Pioneer",
      "STRENGTH TO MIND": "Resourceful Thinker",
      "STRENGTH TO SOUL": "Resourceful Sage",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeThree = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Qualitative Advocate",
      "HEART TO MIND": "Culture Builder",
      "HEART TO STRENGTH": "Team Energizer",
      "SOUL TO MIND": "Thoughtful Communicator",
      "MIND TO HEART": "Compassionate Guide",
      "MIND TO SOUL": "Purpose-Driven Leader",
      "MIND TO STRENGTH": "Analytical Achiever",
      "SOUL TO HEART": "Relational Builder",
      "SOUL TO STRENGTH": "Driven Innovator",
      "STRENGTH TO HEART": "Community Builder",
      "STRENGTH TO MIND": "Considerate Driver",
      "STRENGTH TO SOUL": "Practical Mentor",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeFour = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Impractical Feeler",
      "HEART TO MIND": "Passive Strategist",
      "HEART TO STRENGTH": "Impulsive Drivers",
      "SOUL TO MIND": "Detached Idealist",
      "MIND TO HEART": "Oversensitive Analyst",
      "MIND TO SOUL": "Elusive Partner",
      "MIND TO STRENGTH": "Over-Analyzer",
      "SOUL TO HEART": "Disengaged Feeler",
      "SOUL TO STRENGTH": "Lone Wolf",
      "STRENGTH TO HEART": "Impulsive Reactor",
      "STRENGTH TO MIND": "Cold Pragmatist",
      "STRENGTH TO SOUL": "Detached Warrior",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeFive = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Complicated Connector",
      "HEART TO MIND": "Avoidant Decision-Maker",
      "HEART TO STRENGTH": "Short-sighted Steamroller",
      "SOUL TO MIND": "Big-Idea Drifter",
      "MIND TO HEART": "Burdened Planner",
      "MIND TO SOUL": "Idealistic Drifter",
      "MIND TO STRENGTH": "Lone Ranger",
      "SOUL TO HEART": "Over-absorbed Empath",
      "SOUL TO STRENGTH": "Isolated Visionary",
      "STRENGTH TO HEART": "Erratic Enthusiast",
      "STRENGTH TO MIND": "Stubborn Individualist",
      "STRENGTH TO SOUL": "Forceful Idealist",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeSix = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Idealistic Dreamer",
      "HEART TO MIND": "Over-functioning Caretaker",
      "HEART TO STRENGTH": "Emotional Time-bomb",
      "SOUL TO MIND": "Cold Philosopher",
      "MIND TO HEART": "Reluctant Engager",
      "MIND TO SOUL": "Quiet Idealist",
      "MIND TO STRENGTH": "Rigid Enforcer",
      "SOUL TO HEART": "Low-Assertive Idealist",
      "SOUL TO STRENGTH": "Idealistic Pioneer",
      "STRENGTH TO HEART": "Coercive Connector",
      "STRENGTH TO MIND": "Relentless Taskmaster",
      "STRENGTH TO SOUL": "Pessimistic Dreamer",
    };

    return contentMap[flowText] || "";
  }


  const imagesMap = {
    Soul: { icon: SoulIcon, label: "Soul" },
    Heart: { icon: HeartIcon, label: "Heart" },
    Mind: { icon: MindIcon, label: "Mind" },
    Strength: { icon: StrengthIcon, label: "Strength" },
  };
  const sortedScores = applyFullTieOrder(averagePercentagesSelf?.slice().sort((a, b) => b.avg - a.avg), (el) => el.name, (el) => el.avg)?.map((el) => { return { name: el.name, value: el.avg } })
  const sortedImages = sortedScores?.map(item => imagesMap[item.name]);

  const sortedScores360 = applyFullTieOrder(averagePercentages?.slice().sort((a, b) => b.avg - a.avg), (el) => el.name, (el) => el.avg)?.map((el) => { return { name: el.name, value: el.avg } })
  const sortedImages360 = sortedScores360?.map(item => imagesMap[item.name]);

  const sortedAndRoundedArray = [...snapshotResult]
    .sort((a, b) => b - a)
    .map(value => Math.round(value));

  const baseSize = 88;
  const sizeDecrement = 30;
  const sizeSequence = [88, 64, 50, 28];
  const minSize = sizeSequence[sizeSequence.length - 1];
  const imageSizes = sortedImages.map((_, index) =>
    sizeSequence[index] || Math.max(minSize, baseSize - index * sizeDecrement)
  );
  const itemWidth = Math.max(...imageSizes) + 20;
  // 360 aggregation logic (copied/adapted from StarterQuardrant360)
  const calculate360AggregatedData = () => {

    const aggregated360Results = sorted360AvgPercentage?.map((el) => { return el.value })
    const aggregated360Label = sorted360AvgPercentage?.map((el) => { return el.name })
    setAggregated360Results(aggregated360Results);
    setAggregated360Label(aggregated360Label)
    // setAggregated360Highest((prev) => (prev === overallHighest ? prev : overallHighest));
  };

  useEffect(() => {
    if (apiData?.memberResults?.allMembersData) {
      calculate360AggregatedData();
    }
  }, [membersKey]);

  const Arrow = () => (
    <svg width="70" height="28" viewBox="0 0 70 28" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
      <line x1="0" y1="12" x2="70" y2="12" stroke="#245775" strokeWidth="3.6" />
      <path d="M30 3L40 12L30 21" fill="none" stroke="#245775" strokeWidth="3.6" />
    </svg>

  );



  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview />
      <div className="three60-heart-to-soul-container">
        <div className="heart-to-soul-container">
          <div className="header-section" style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
            <img src={getFlowImage()} alt="Heart to Soul Flow" style={{ width: '108px', height: '108px' }} />
            <div className="text-content">
              <h2 style={{
                fontFamily: 'Helvetica',
                fontWeight: 700,
                fontStyle: 'normal',
                fontSize: '10px',
                lineHeight: '14px',
                letterSpacing: '0px',
                textTransform: 'uppercase',
                color: '#000000',
                margin: 0,
                paddingBottom: "5px",
              }}>YOU FLOW FROM {getFlowHead()} (360)</h2>
              <p style={{
                fontFamily: 'Helvetica',
                fontWeight: 700,
                fontStyle: 'normal',
                fontSize: '10px',
                lineHeight: '14px',
                letterSpacing: '0px',
                color: '#000000',
                margin: 0,
                paddingBottom: "5px",
              }}>{flowTagline(getFlowHead())}</p>
              <h3 style={{
                fontFamily: 'Helvetica',
                fontWeight: 700,
                fontStyle: 'normal',
                fontSize: '10px',
                lineHeight: '14px',
                letterSpacing: '0px',
                color: '#000000',
                margin: 0,
                paddingBottom: "5px",
                textTransform: "uppercase",
              }}>Possible Archetypes</h3>
              <div style={{
                display: 'flex',
                gap: '32px'
              }}>
                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  fontFamily: 'Helvetica',
                  fontWeight: 400,
                  fontStyle: 'normal',
                  fontSize: '10px',
                  lineHeight: '14px',
                  letterSpacing: '0px',
                  color: '#000000'
                }}>
                  <li style={{ paddingBottom: "4px" }}>• {ArchtypeOne(getFlowHead())}</li>
                  <li style={{ paddingBottom: "4px" }}>• {ArchtypeTwo(getFlowHead())}</li>
                  <li style={{ paddingBottom: "4px" }}>• {ArchtypeThree(getFlowHead())}</li>
                </ul>
                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  fontFamily: 'Helvetica',
                  fontWeight: 400,
                  fontStyle: 'normal',
                  fontSize: '10px',
                  lineHeight: '14px',
                  letterSpacing: '0px',
                  color: '#000000'
                }}>
                  <li style={{ paddingBottom: "4px" }}>• {ArchtypeFour(getFlowHead())}</li>
                  <li style={{ paddingBottom: "4px" }}>• {ArchtypeFive(getFlowHead())}</li>
                  <li style={{ paddingBottom: "4px" }}>• {ArchtypeSix(getFlowHead())}</li>
                </ul>
              </div>
            </div>
          </div>
          <div style={{
            fontSize: '10px',
            fontWeight: 400,
            color: '#000000',
            fontFamily: 'Helvetica',
            lineHeight: '14px',
            position: 'relative',
          }}>
            {sectionFlowContent(getFlowHead())}
            <br /><br />
            {paraOne(getFlowHead())}
            {paraTwo(getFlowHead()) && (
              <>
                <br /><br />
                {paraTwo(getFlowHead())}
              </>
            )}
          </div>

          <div className="three60-flow-bar-wrapper" style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "412px",
          }} >
            <h2 className="three60-flow-start-heading">Your Quadrant Flow - Self is:</h2>
            <p style={{
              position: "absolute",
              left: "10%",
              transform: "translateX(-50%)",
              top: "8%",
              fontSize: '10px',
              fontWeight: 700,
              color: '#245775',
              fontFamily: 'Helvetica',
              margin: 0,
              marginBottom: '8px'
            }}>Start</p>
            <div className="three60-flow-image-bar" style={{
              width: "100%",
              maxWidth: "412px",
              display: 'flex',
              flexDirection: "row",
              gap: "57px",
              alignItems: "center",
              justifyContent: "center"
            }}>
              {sortedImages?.map((item, index) => (
                <div key={index} className="three60-flow-image-group"
                  style={{
                    display: 'flex',
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                    width: `${itemWidth}px`,
                    // width: index === sortedImages.length - 1 ? `${imageSizes[index]}px` : `${imageSizes[index] + 140}px`
                  }} >
                  <img
                    src={item.icon}
                    alt={item.label}
                    style={{ width: `${imageSizes[index]}px`, height: `${imageSizes[index]}px`, zIndex:'999' }}
                  />
                  {index < sortedImages?.length - 1 && (
                    <div style={{
                      position: "absolute",
                      top: `${imageSizes[index] / 2}px`,
                      left: index === 0
                        ? "81px"
                        : index === 1
                          ? "61.5px"
                          : index === 2
                            ? "48px"
                            : "0px",
                      width: index == 2
                        ? "82px" : "74px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <span style={{
                        position: "absolute",
                        fontSize: 50,
                        fontWeight: 300,
                        top: -30,
                        left: 0,
                        color: "#245775",
                        fontFamily: 'Helvetica'
                      }}>
                        <Arrow />
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div style={{
              width: "100%",
              display: 'flex',
              flexDirection: "row",
              gap: "60px",
              alignItems: "center",
              justifyContent: "start"
            }}>
              {sortedImages.map((item, index) => (
                <div key={index} style={{
                  display: 'flex',
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  width: `${imageSizes[index]}px`,
                }}>
                  <div style={{
                    marginTop: '5px',
                    textAlign: 'center',
                    width: `${imageSizes[index]}px`,
                    minWidth: "fit-content",
                  }}>
                    <p style={{
                      margin: 0,
                      lineHeight: '14px',
                      fontWeight: 700,
                      fontSize: '10px',
                      color: '#245775',
                      fontFamily: 'Helvetica'
                    }}>{item.label}</p>
                    <p style={{
                      margin: 0,
                      fontSize: '10px',
                      color: '#5795B2',
                      fontWeight: 400,
                      textAlign: 'center',
                      lineHeight: '14px',
                      fontFamily: 'Helvetica'
                    }}>{typeof sortedScores[index].value === 'number' ? parseFloat(sortedScores[index].value) : parseFloat(sortedScores[index].value)}%</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "412px",
          }} className="three60-flow-bar-wrapper">
            <h2 className="three60-flow-start-heading">Your Quadrant Flow - 360 is:</h2>
            <p style={{
              position: "absolute",
              left: "10%",
              transform: "translateX(-50%)",
              top: "8%",
              fontSize: '10px',
              fontWeight: 700,
              color: '#245775',
              fontFamily: 'Helvetica',
              margin: 0,
              marginBottom: '8px'
            }}>Start</p>
            <div className="three60-flow-image-bar" style={{
              width: "100%",
              maxWidth: "412px",
              display: 'flex',
              flexDirection: "row",
              gap: "57px",
              alignItems: "center",
              justifyContent: "center"
            }}>
              {sortedImages360?.map((item, index) => (
                <div key={index} className="three60-flow-image-group"
                  style={{
                    display: 'flex',
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                    width: `${itemWidth}px`,
                    // width: index === sortedImages.length - 1 ? `${imageSizes[index]}px` : `${imageSizes[index] + 140}px`
                  }} >
                  <img
                    src={item.icon}
                    alt={item.label}
                    style={{ width: `${imageSizes[index]}px`, height: `${imageSizes[index]}px`, zIndex: "9999" }}
                  />
                  {index < sortedImages360?.length - 1 && (
                    <div style={{
                      position: "absolute",
                      top: `${imageSizes[index] / 2}px`,
                      left: index === 0
                        ? "81px"
                        : index === 1
                          ? "61.5px"
                          : index === 2
                            ? "48px"
                            : "0px",
                      width: index == 2
                        ? "82px" : "74px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <span style={{
                        position: "absolute",
                        fontSize: 50,
                        fontWeight: 300,
                        top: -30,
                        left: 0,
                        color: "#245775",
                        fontFamily: 'Helvetica'
                      }}>
                        <Arrow />
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div style={{
              width: "100%",
              display: 'flex',
              flexDirection: "row",
              gap: "60px",
              alignItems: "center",
              justifyContent: "start"
            }}>
              {sortedImages360.map((item, index) => (
                <div key={index} style={{
                  display: 'flex',
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  width: `${imageSizes[index]}px`,
                }}>
                  <div style={{
                    marginTop: '5px',
                    textAlign: 'center',
                    width: `${imageSizes[index]}px`,
                    minWidth: "fit-content",
                  }}>
                    <p style={{
                      margin: 0,
                      lineHeight: '14px',
                      fontWeight: 700,
                      fontSize: '10px',
                      color: '#245775',
                      fontFamily: 'Helvetica'
                    }}>{item.label}</p>
                    <p style={{
                      margin: 0,
                      fontSize: '10px',
                      color: '#5795B2',
                      fontWeight: 400,
                      textAlign: 'center',
                      lineHeight: '14px',
                      fontFamily: 'Helvetica'
                    }}>{typeof sortedScores360[index].value === 'number' ? parseFloat(sortedScores360[index].value).toFixed(2) : parseFloat(sortedScores360[index].value).toFixed(2)}%</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>

  );
}

export default HeartToSoulPreview360;
